import { ReactNode } from 'react';

import staticStyles from './boxContainer.module.scss';

interface BoxContainerProps {
  children: ReactNode;
  styles?: string;
  id?: string;
}

export const BoxContainer = ({ children, styles, id }: BoxContainerProps) => {
  return (
    <div id={id ?? ''} className={`${staticStyles.container} ${styles ?? ''}`}>
      {children}
    </div>
  );
};
